<app-layout preset="data">
  <app-layout-title>
    <app-go-back-button (click)="goBack()">
      {{ 'ADMIN.matchers' | translate }}
    </app-go-back-button>
  </app-layout-title>

  <app-layout-actions>
    <button (click)="openCreateMatcherDialog()" class="state-check-button" color="primary" mat-stroked-button>
      <mat-icon>add</mat-icon>
      {{ 'COMMON.add' | translate }}
    </button>
  </app-layout-actions>

  <app-layout-content>
    <app-hint>
      <span>
        {{ 'ADMIN.priority_hint' | translate }} <mat-icon>keyboard_arrow_up</mat-icon> {{ 'ADMIN.and' | translate }} <mat-icon>keyboard_arrow_down</mat-icon>
      </span>
    </app-hint>

    <div class="table-wrapper">
      <app-table [columns]="columns" [dataSource]="dataSource" [reloader]="matcherReloader" loadingType="all">
        <app-table-row [rowClasses]="rowClasses"></app-table-row>

        <ng-container *app-table-header="'move'">
          @if (priorityChangeTask && !priorityChangeTask.closed) {
            <div class="priority-update">
              <span>{{ 'ADMIN.updating' | translate }}</span>
              <mat-spinner [diameter]="20" class="priority-update-spinner"></mat-spinner>
            </div>
          }
        </ng-container>

        <ng-container *app-table-header="'name'">{{ 'COURIER_MATCHERS.TABLE.name' | translate }}</ng-container>
        <ng-container *app-table-header="'state'">{{ 'COURIER_MATCHERS.TABLE.state' | translate }}</ng-container>
        <ng-container *app-table-header="'filter'">{{ 'COURIER_MATCHERS.TABLE.filter' | translate }}</ng-container>
        <ng-container *app-table-header="'actions'">{{ 'COURIER_MATCHERS.TABLE.actions' | translate }}</ng-container>

        <ng-container *app-table-column="let matcher, name: 'move'">
          <div>
            <button (click)="moveUp(matcher)" mat-icon-button>
              <mat-icon>keyboard_arrow_up</mat-icon>
            </button>
            <button (click)="moveDown(matcher)" mat-icon-button>
              <mat-icon>keyboard_arrow_down</mat-icon>
            </button>
          </div>
        </ng-container>

        <ng-container *app-table-column="let matcher, name: 'name'">
          {{matcher.name}}
        </ng-container>

        <ng-container *app-table-column="let matcher, name: 'state'">
          {{ matcher.state | label:'courier-states' | async }}
        </ng-container>

        <ng-container *app-table-column="let matcher, name: 'filter'">
          <app-rule-view [style.textAlign]="'left'" [rule]="matcher.ruleSet"
          [orderFieldMap]="orderFieldMap"></app-rule-view>
        </ng-container>

        <ng-container *app-table-column="let matcher, name: 'actions'">
          <button (click)="openUpdateMatcherDialog(matcher)" color="primary" mat-icon-button>
            <mat-icon>edit</mat-icon>
          </button>
          <app-delete-popover (action)="removeMatcher(matcher)" [matTooltip]="'QUERY_BUILDER.delete' | translate">
            {{ 'ADMIN.delete_matcher' | translate:{ name: matcher.name } }}
          </app-delete-popover>
        </ng-container>
      </app-table>
    </div>

    <div class="state-check">
      <mat-form-field class="state-check-input">
        <mat-label>{{ 'DIALOGS.ASSOCIATION.title' | translate }}</mat-label>
        <input [(ngModel)]="statusForCheck" matInput name="status" [placeholder]="'ADMIN.tracking_status' | translate">
      </mat-form-field>
      <button (click)="runMatching()" [disabled]="!statusForCheck || isCheckLocked" class="state-check-button"
        color="primary"
        mat-stroked-button>
        <mat-icon>search</mat-icon>
        {{ 'ADMIN.check' | translate }}
      </button>
    </div>
  </app-layout-content>
</app-layout>
